import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const MAX_COUNT = 20

interface SearchHistoryState {
  history: string[];
  addQuery: (query: string) => void;
  clearHistory: () => void;
}

export const useSearchHistoryStore = create<SearchHistoryState>()(
  persist(
    (set) => ({
      history: [],

      addQuery: (query: string) => {
        const trimmed = query.trim()
        if (!trimmed) return

        set((state) => {
          if (state.history.includes(trimmed)) {
            return {}
          }

          const updated = [ trimmed, ...state.history ].slice(0, MAX_COUNT)
          return { history: updated }
        })
      },

      clearHistory: () => {
        set({ history: [] })
      },
    }),
    {
      name: 'search-history-storage',
    },
  ),
)
